import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { CheckCircle as CheckCircleIcon, Close as CloseIcon } from "@mui/icons-material";

const SuccessModal = ({ 
  open, 
  onClose, 
  title = "Message Sent!", 
  message = "Thank you for reaching out. Our team will get back to you shortly.",
  buttonText = "Okay"
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 2,
          minWidth: { xs: "300px", sm: "450px" }, 
          textAlign: "center",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
        },
      }}
    >
      <Box position="absolute" top={10} right={10}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 4,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 80, color: "#8BC34A", mb: 2 }} />

        <Typography
          variant="h5"
          fontWeight="800"
          sx={{ color: "#0a1a3b", mb: 1 }}
        >
          {title}
        </Typography>

      
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ 
            mb: 4, 
            fontSize: "1.2rem", 
            lineHeight: 1.5,
            maxWidth: "90%" 
          }}
        >
          {message}
        </Typography>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: "#00C4F0",
            borderRadius: 50,
            px: 6,
            py: 1.2,
            fontSize: "1rem",
            fontWeight: "bold",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#00a7d6" },
          }}
        >
          {buttonText}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;